import React from "react";

const NotFoundPage = () => {
    return (
        <div className="wrapper">
            <div className="page">

            </div>
        </div>
    )
}

export default NotFoundPage;